<template>
  <small class="inline-block text-sm text-disabled-01" data-testid="clr-helper-text">
    <slot />
  </small>
</template>
